import axios from "axios"
import { API_URL, getHeaders } from "../config";

export const submitModuleFeedback = async(feedbackText, feedbackRating, categoryId) => {
    return axios.post(`${API_URL}/api/PPT/feedback/send-feeback`,
        { feedbackText, feedbackRating, categoryId },
        { headers: getHeaders().headers },
    );
};